import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { FitnessClass, FitnessClassesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class FitnessClassesDataService {

  private uri: string = `${environment.apiUrl}fitness-classes`;
  private cacheKey: string = 'fitnessClasses.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getFitnessClass(id: number): Observable<FitnessClass|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getFitnessClasses(parameters: {[param: string]: string | string[]}): Observable<FitnessClassesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addFitnessClass(data: FitnessClass): Observable<FitnessClass|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addFitnessClasses(data: FitnessClass[]): Observable<FitnessClass[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateFitnessClass(data: FitnessClass): Observable<FitnessClass|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateFitnessClasses(data: FitnessClass[]): Observable<FitnessClass[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchFitnessClass(data: FitnessClass): Observable<FitnessClass|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchFitnessClasses(data: FitnessClass[]): Observable<FitnessClass[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteFitnessClass(data: FitnessClass): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteFitnessClasses(data: FitnessClass[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((fitnessClass) => {
      ids.push(fitnessClass.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
